module.exports = __webpack_public_path__ + "static/media/US_Flag_Small.404198b9.svg";